const state = {
  context: null,
  contexts: {},
  login: false,
  purgeClientData: false,
}

export default state